declare const window: any;

export const hasConsent = () => {
  return window.initProps.mscc.hasConsent || (window.mscc && window.mscc.hasConsent());
};
